module.exports = __webpack_public_path__ + "img/icon_symbolmute_gray.45c165be.svg";